import React from "react";
import { Empty as AntdEmpty } from "antd";
import { EmptyProps as AntdEmptyProps } from "antd";
import * as styles from "./Empty.css";

export interface EmptyProps extends AntdEmptyProps {
  /** Custom background color for the Empty component */
  backgroundColor?: string;
  /** Custom text color for the description */
  textColor?: string;
}

const Empty: React.FC<EmptyProps> = ({
  backgroundColor = "#ffffff",
  textColor = "#595959",
  description = "No Data",
  ...props
}) => {
  return (
    <div className={styles.emptyContainer} style={{ backgroundColor }}>
      <AntdEmpty
        description={
          <span
            className={styles.emptyDescription}
            style={{ color: textColor }}
          >
            {description}
          </span>
        }
        {...props}
      />
    </div>
  );
};

export default Empty;
